import React, { Component, Fragment } from "react";
import LocalEventsEditorModal from "./LocalEventsEditorModal";
import { pmaActions } from "_store/_actions";
import { connect } from "react-redux";
import AddAreasModal from "views/Pma/PmaEditor/TableQuadrants/TableQuadrantsPageOne/AddAreasModal";

class LocalEvents extends Component {
  state = {
    editQuadrantFormData: null,
    originalEditQuadrantFormData: null,
    oldQuadrantData: [],
    oldEditForm: [],
    selectedQuadrantNumber: null,
    titleEdit: false,
    maxMainTitleLength: 30,
    addAreasModalOpen: false,
    filteredAreas: {},
    maxMainSubtitleLength: 40,
    savingMessageShowing: false,
    duplicateError: null,
  };

  checkForDuplicates = () => {
    console.log("checkForDuplicates");
    const { editQuadrantFormData } = this.state;
    const events = [];

    // Collect all events
    for (let i = 1; i <= 5; i++) {
      const title = editQuadrantFormData[`eventHeading${i}`];
      const text = editQuadrantFormData[`eventText${i}`];
      const footer = editQuadrantFormData[`eventFooter${i}`];
      if (title || text || footer) {
        events.push({ title, text, footer, index: i });
      }
    }
    console.log("events", events);

    // Check for duplicates
    for (let i = 0; i < events.length - 1; i++) {
      for (let j = i + 1; j < events.length - 1; j++) {
        if (
          events[i].title === events[j].title &&
          events[i].text === events[j].text &&
          events[i].footer === events[j].footer
        ) {
          console.log("duplicate found", events[i].index, events[j].index);
          return {
            hasDuplicates: true,
            sections: [events[i].index, events[j].index],
          };
        }
      }
    }

    return { hasDuplicates: false };
  };

  handleFormClose = (quadNum) => {
    const { localEventsDetails, currentArea, agentData } = this.props;
    const { oldQuadrantData, oldEditForm } = this.state;
    const { listgenUserID } = agentData;
    const events = Array.isArray(localEventsDetails) ? localEventsDetails : [];

    this.setState(
      {
        titleEdit: false,
        addAreasModalOpen: false,
        savingMessageShowing: false,
        editQuadrantFormData: oldEditForm,
        duplicateError: null,
      },
      () => {
        this.props.setLocalEventsDetails(oldQuadrantData, listgenUserID);
      },
    );

    this.setState({
      oldQuadrantData: events.map((i) => ({ ...i })),
      editQuadrantFormData:
        events
          .filter(
            (quadrantObj) => quadrantObj.eventAreaID === currentArea.mlsAreaID,
          )
          .map((i) => ({ ...i }))[0] || null,
    });

    this.props.updateQuadrantModalOpen(false);
  };

  onEditFormSubmit = () => {
    const { editQuadrantFormData, oldQuadrantData, titleEdit } = this.state;
    const { agentData } = this.props;
    const { listgenUserID } = agentData;

    if (!titleEdit) {
      const duplicateCheck = this.checkForDuplicates();
      if (duplicateCheck.hasDuplicates) {
        this.setState({
          duplicateError: `You cannot have 2 of the same events selected (Sections ${duplicateCheck.sections[0]} and ${duplicateCheck.sections[1]} are identical)`,
        });
        return;
      }
    }

    const nextQuadrantData = [...oldQuadrantData];
    const foundIndex = nextQuadrantData.findIndex(
      (x) => x.eventAreaID == editQuadrantFormData.eventAreaID,
    );
    if (foundIndex === -1) {
      nextQuadrantData.push(editQuadrantFormData);
    } else {
      nextQuadrantData[foundIndex] = editQuadrantFormData;
    }

    this.setState({
      oldQuadrantData: nextQuadrantData,
      titleEdit: false,
      duplicateError: null,
    });
    this.props.setLocalEventsDetails(nextQuadrantData, listgenUserID);
    this.props.updateQuadrantModalOpen(false);
  };

  openSelectedQuadrant = (quadrantNumber, titleEdit = false) => {
    const { editQuadrantFormData, oldQuadrantData } = this.state;

    const foundIndex = oldQuadrantData.findIndex(
      (x) => x.eventAreaID == editQuadrantFormData?.eventAreaID,
    );
    const currentOldData =
      foundIndex >= 0
        ? { ...oldQuadrantData[foundIndex] }
        : { ...editQuadrantFormData };

    this.setState(
      {
        selectedQuadrantNumber: quadrantNumber,
        titleEdit,
        savingMessageShowing: false,
        oldEditForm: currentOldData,
        duplicateError: null,
      },
      () => {
        this.props.updateQuadrantModalOpen(true);
      },
    );
  };
  componentDidMount = () => {
    require("./print.scss");
    if (this.props.fromEditor) {
      require("./editor.scss");
    }

    const { localEventsDetails, currentArea } = this.props;
    console.log("*****localEventsDetails", localEventsDetails);
    this.props.updateQuadrantModalOpen(false);

    const events = Array.isArray(localEventsDetails) ? localEventsDetails : [];
    let newObj = events
      .filter(
        (quadrantObj) => quadrantObj.eventAreaID === currentArea.mlsAreaID,
      )
      .map((i) => ({ ...i }))[0];

    if (!newObj && currentArea.mlsAreaID.includes("DEMO")) {
      newObj = events[0];
    }

    this.setState({
      oldQuadrantData: events.map((i) => ({ ...i })),
      editQuadrantFormData: newObj || null,
    });
  };
  handleRestoreDefault = () => {
    const {
      selectedQuadrantNumber,
      editQuadrantFormData,
      oldQuadrantData,
      titleEdit,
    } = this.state;
    let past = oldQuadrantData[selectedQuadrantNumber];
    if (titleEdit) {
      const { oldEditForm } = this.state;
      if (oldEditForm) {
        this.setState({
          editQuadrantFormData: {
            ...editQuadrantFormData,
            eventAreaTitle: oldEditForm.eventAreaTitle,
            eventAreaSubTitle: oldEditForm.eventAreaSubTitle,
          },
        });
      }
    } else if (selectedQuadrantNumber >= 0) {
      let newObj = [...editQuadrantFormData].map((i) => ({ ...i }));

      let oldSelection = [...oldQuadrantData].map((i) => ({
        ...i,
      }))[selectedQuadrantNumber];

      newObj[selectedQuadrantNumber].text = oldSelection.text;

      this.setState({
        editQuadrantFormData: newObj,
      });
    }
  };
  handleInputChange = (e) => {
    const { editQuadrantFormData } = this.state;
    const target = e.target;
    const value = target.value;
    const name = target.name;
    let clonedEditQuadrantFormData = Object.assign(editQuadrantFormData, {
      [name]: value,
    });
    this.setState({
      editQuadrantFormData: clonedEditQuadrantFormData,
      duplicateError: null, // Clear error when user makes changes
    });
  };
  selectEventText = (organization, selectedQuadrantNumber) => {
    const { editQuadrantFormData } = this.state;
    const { localEventHeader, localEventText, localEventFooter } = organization;
    let titleToChange = `eventHeading${selectedQuadrantNumber}`;
    let textToChange = `eventText${selectedQuadrantNumber}`;
    let websiteURLToChange = `eventFooter${selectedQuadrantNumber}`;
    let clonedEditQuadrantFormData = Object.assign(editQuadrantFormData, {
      [titleToChange]: localEventHeader,
      [textToChange]: localEventText,
      [websiteURLToChange]: localEventFooter,
    });

    this.setState({
      editQuadrantFormData: clonedEditQuadrantFormData,
    });
  };
  applyToAllAreas = () => {
    console.log("applyToAllAreas");
  };

  render() {
    // console.log(this.props.currentArea);
    const { mlsAreaID } = this.props.currentArea;
    const {
      mlsAreas,
      quadrantModalOpen,
      currentArea,
      printVersion,
      agentData,
      altAgentData,
      fromEditor,
    } = this.props;
    const { listgenUserID } = agentData;
    const {
      openSelectedQuadrant,
      handleInputChange,
      handleRestoreDefault,
      selectEventText,
    } = this;
    const {
      editQuadrantFormData,
      oldQuadrantData,
      selectedQuadrantNumber,
      titleEdit,

      addAreasModalOpen,
      maxMainTitleLength,
      maxMainSubtitleLength,
      savingMessageShowing,
    } = this.state;
    let subtitleStyles;
    let quadrantStyles;
    const { showAllEditButtons } = this.props;
    let showButtons = fromEditor && showAllEditButtons;

    let sectionTitleStyles;
    if (editQuadrantFormData) {
      for (const key in editQuadrantFormData) {
        let value = editQuadrantFormData[key];
        if (key && key.includes("eventHeading")) {
          if (value && value.length >= 45) {
            sectionTitleStyles = "event-title-16";
          }
        }
      }
    }
    if (editQuadrantFormData && Object.keys(editQuadrantFormData).length >= 1) {
      const { eventAreaTitle, eventAreaSubTitle } = editQuadrantFormData;
      return (
        <Fragment>
          {addAreasModalOpen && (
            <AddAreasModal
              addAreasModalOpen={addAreasModalOpen}
              mlsAreas={mlsAreas}
              currentArea={currentArea}
              onCloseFn={this.handleFormClose}
              onEditFormSubmit={this.onEditFormSubmit}
              editQuadrantFormData={editQuadrantFormData}
            />
          )}
          <div
            className={`${
              printVersion
                ? "print-local-events-container"
                : "editor-local-events-container"
            }${fromEditor ? " from-editor" : ""} ${quadrantStyles && quadrantStyles} `}
          >
            {editQuadrantFormData &&
              Object.keys(editQuadrantFormData).length >= 1 &&
              quadrantModalOpen && (
                <LocalEventsEditorModal
                  oldQuadrantData={oldQuadrantData}
                  onCloseFn={this.handleFormClose}
                  handleInputChange={handleInputChange}
                  editQuadrantFormData={editQuadrantFormData}
                  onEditFormSubmit={this.onEditFormSubmit}
                  selectedQuadrantNumber={selectedQuadrantNumber}
                  handleRestoreDefault={handleRestoreDefault}
                  titleEdit={titleEdit}
                  mlsAreas={mlsAreas}
                  maxMainTitleLength={maxMainTitleLength}
                  maxMainSubtitleLength={maxMainSubtitleLength}
                  savingMessageShowing={savingMessageShowing}
                  selectEventText={selectEventText}
                  currentArea={currentArea}
                  agentData={agentData}
                  altAgentData={altAgentData}
                  fromEditor={fromEditor}
                  duplicateError={this.state.duplicateError}
                />
              )}
            {showButtons && (
              <>
                <p className="local-events-verify-notice" role="status">
                  Please verify all your Summer Events and dates are accurate
                  before approving.
                </p>
                <div
                  className="local-events-btn local-events-title-btn"
                  onClick={() => openSelectedQuadrant(null, true)}
                >
                  <div>Edit the Header</div>
                </div>
                <div
                  className="local-events-btn local-events-btn-1"
                  onClick={() => openSelectedQuadrant(1, false)}
                >
                  <div>Edit This Event</div>
                </div>
                <div
                  className="local-events-btn local-events-btn-2"
                  onClick={() => openSelectedQuadrant(2, false)}
                >
                  <div>Edit This Event</div>
                </div>
                <div
                  className="local-events-btn local-events-btn-3"
                  onClick={() => openSelectedQuadrant(3, false)}
                >
                  <div>Edit This Event</div>
                </div>
                <div
                  className="local-events-btn local-events-btn-4"
                  onClick={() => openSelectedQuadrant(4, false)}
                >
                  <div>Edit This Event</div>
                </div>
              </>
            )}
            <img
              className="local-events-bg-img"
              src={
                "https://d2onbxnrte2nim.cloudfront.net/non-covers/052726_JunePMA_BackCover-Wshapes-1.png"
              }
              alt="Local Events"
            />
            <div className="local-events">
              <div className="local-events-title-container">
                <div
                  className="local-events-title-text"
                  dangerouslySetInnerHTML={{ __html: eventAreaTitle }}
                ></div>
                {/*}<div
                  className={`local-events-subtitle-text ${subtitleStyles}`}
                  dangerouslySetInnerHTML={{ __html: eventAreaSubTitle }}
                ></div>*/}
              </div>

              <div className="local-events-body">
                <div className="section-container">
                  <div className="section-row">
                    {[0, 1, 2, 3].map((quadrant, i) => {
                      let index = i + 1;

                      let quadNumTitle =
                        editQuadrantFormData[`eventHeading${index}`];
                      let quadNumText =
                        editQuadrantFormData[`eventText${index}`];
                      let quadWebsiteURL =
                        editQuadrantFormData[`eventFooter${index}`];
                      return (
                        <div
                          className={`${
                            index == selectedQuadrantNumber &&
                            "selected-local-events-section"
                          } local-events-section section-${index}`}
                          key={index}
                        >
                          <div className="local-events-index-num">{index}</div>
                          <div className="local-events-section-title-and-text-container">
                            <div className="local-events-section-title-and-text">
                              <p
                                className={`local-events-section-title ${sectionTitleStyles}`}
                              >
                                {quadNumTitle}
                              </p>
                              <p className="local-events-section-text">
                                {quadNumText}
                              </p>
                              <p className="local-events-section-websiteURL">
                                {quadWebsiteURL}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    quadrantModalOpen: state.pma.quadrantModalOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // switchPropertyHighlightsPage: (listgenUserID, mlsAreaID, isBackPage) => {
    //   dispatch(
    //     pmaActions.switchPropertyHighlightsPage(
    //       listgenUserID,
    //       mlsAreaID,
    //       isBackPage
    //     )
    //   );
    // },
    updateQuadrantModalOpen: (isModalOpen) => {
      dispatch(pmaActions.updateQuadrantModalOpen(isModalOpen));
    },
    setLocalEventsDetails: (localEventsDetails, listgenUserID) => {
      dispatch(
        pmaActions.setLocalEventsDetails(localEventsDetails, listgenUserID),
      );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LocalEvents);
